import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-256" data-mp="llmeqapej3bq">
      <HeroSection data-id="element-257" data-mp="lnh17tgbn3hx" />
      <ProofSection data-id="element-258" data-mp="lnz77hsscw31" />
      <ProblemSection data-id="element-259" data-mp="2zj6zr7ne5t6s" />
      <SystemSection data-id="element-260" data-mp="2zjykfnfga6ia" />
      <ModulesSection data-id="element-261" data-mp="2zki3j7gu70xw" />
      <BonusSection data-id="element-262" data-mp="2zh3ytskpafna" />
      <UrgencySection data-id="element-263" data-mp="33k8zdpl8079a" />
      <PricingSection data-id="element-264" data-mp="33jqt004ugcnn" />
      <TestimonialsSection data-id="element-265" data-mp="33l1xk2645oft" />
      <GuaranteeSection data-id="element-266" data-mp="33i5z8cqcsxqu" />
      <FAQSection data-id="element-267" data-mp="38j3hsqf9ztsv" />
      <FinalCTA data-id="element-268" data-mp="38ika02jcalsk" />
      <Footer data-id="element-269" data-mp="38i25yjqfr3a3" />
      <PurchasePopup data-id="element-270" data-mp="38iag43v6buhl" />
    </main>;
}